<template>
  <div class="rules-container">
    <Modal
      title
      scrollable
      v-model="rules"
      @on-cancel="close"
      width="530"
      class-name="vertical-center-modal rules-modal"
    >
      <div v-html="returnData"></div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "DeliveryRules",
  data() {
    return {
      visitStatus: false
    };
  },
  props: {
    rules: {
      type: Boolean,
      default: false
    },
    returnData: {
      type: String,
      default: ""
    }
  },
  components: {},
  methods: {
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
}
/deep/.rules-modal .ivu-modal-content {
  width: 53rem;
  min-height: 25rem;
  padding: 4rem;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #5c5d5f;
  text-align: left;
  border: 0.1rem solid #959595;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
/deep/.rules-modal .ivu-modal-body {
  padding: 0;
  line-height: 1.2;
  font-size: 1.2rem;
}
/deep/.ivu-modal-mask {
  background-color: rgba(55, 55, 55, 0);
}
/deep/.ivu-modal-close {
  display: initial;
}
/deep/.ivu-modal {
  margin: 10px 0;
}
/deep/.ivu-modal-content {
  box-shadow: none;
}
@media screen and (max-width: 1024px) {
  /deep/.rules-modal .ivu-modal-content {
    width: calc(100% - 4rem);
    min-height: 15rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/DeliveryRulesPop.vue